<div>
  <mat-tab-group>
    @for (c of categories; track c) {
      <mat-tab [label]="c">
        <div class="maps-grid">
          @for (m of grouped[c]; track m) {
            <div class="map-item" (click)="showPreview($event, m)">
              <img class="thumb" [src]="m.url" [alt]="m.name || m.id"/>
              <div class="map-caption"  (click)="editMap($event, m)">{{m.name || m.url}}</div>
            </div>
          }
        </div>
      </mat-tab>
    }
  </mat-tab-group>

  @if (currentPreview) {
    <div class="preview">
      <img [src]="currentPreview.url" [alt]="currentPreview.name || currentPreview.id"/>
    </div>
  }
</div>

